import { memo, useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useWFHMessages } from "../../hooks";
import { BEST5_INDEX, DISPLAY_EXCHANGE_NAME, MARKETDEPTH_INDEX, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { getBidAndAskGridRowData } from "../../utils/global_functions";
import { getWfhBestFiveLastTick } from "../../redux/actions/wfh";
import { useDispatch, useSelector } from "react-redux";
import { sendBestFiveRequest } from "../../apis/web_socket";

const PriceLadderView = ({ isVertical = true, arrDistinctScripExchanges, }) => {
    const dispatch = useDispatch();
    const [askData, setAskData] = useState({});
    const [bidData, setBidData] = useState({});
    const [sortedAskData, setSortedAskData] = useState([]);
    const [sortedBiddata, setSortedBidData] = useState([]);
    const [bidPer, setBidPer] = useState([])
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const [askPer, setAskPer] = useState([])
    // const [arrMarketDepthData, setArrMarketDepthData] = useState([]);
    const [bidPercent, setBidPercent] = useState(0);
    const [askPercent, setAskPercent] = useState(0);

    const handleMarketDepthDataSubscription = (data, bIsSubscribeUnsubscribeHandler) => {
        sendBestFiveRequest({ exchangeId: data[MARKETDEPTH_INDEX.SEGMENT_ID], token: data[MARKETDEPTH_INDEX.TOKEN], isSubscribe: bIsSubscribeUnsubscribeHandler });
    };
    //Vaibhav Singh: 23-10-24: handleMarketDepthModal function helps market depth subscription  
    const handleMarketDepthModal = useCallback((data, bIssubscribeUnsubscribeHandler) => {
        for (let i = 0; i < data.length; i++) {
            handleMarketDepthDataSubscription(data[i], bIssubscribeUnsubscribeHandler);
        }
    }, []);

    useEffect(() => {
        handleMarketDepthModal(arrDistinctScripExchanges, true);
        return () => handleMarketDepthModal(arrDistinctScripExchanges, false);
    }, [arrDistinctScripExchanges]);

    const calculateBidPercent = (arrDetails) => {
        const bidPercentData = (arrDetails?.[BEST5_INDEX.TOTAL_BUY_QTY] / (arrDetails?.[BEST5_INDEX.TOTAL_BUY_QTY] + arrDetails?.[BEST5_INDEX.TOTAL_SELL_QTY])) * 100;
        setBidPercent(bidPercentData.toFixed(2));
    };

    const calculateAskPercent = (arrDetails) => {
        const askPercentData = ((arrDetails?.[BEST5_INDEX.TOTAL_SELL_QTY] / (arrDetails?.[BEST5_INDEX.TOTAL_BUY_QTY] + arrDetails?.[BEST5_INDEX.TOTAL_SELL_QTY])) * 100);
        setAskPercent(askPercentData.toFixed(2));
    };

    //Vaibhav Singh: 23-10-24: getUniqueData function gives unique data in format that needs to be shown on screen also added concat for data to sorted logically
    const getUniqueData = (exchange, data) => {
        let result = []
        exchange.forEach(innerArray => {
            result.push(innerArray[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN])
        })
        const matchingItems = Object.values(data)?.flat()?.filter(item => result.includes(item.id.split('_').slice(0, -1).join('_')))
        const filteredData = matchingItems?.filter(item => item[item?.ask ? 'ask' : 'bid'] !== '-')?.sort((a, b) => {
            if (a.ask) {
                const askA = isNaN(parseFloat(a.ask)) ? Infinity : parseFloat(a.ask)
                const askB = isNaN(parseFloat(b.ask)) ? Infinity : parseFloat(b.ask)
                return askB - askA
            } else {
                const bidA = isNaN(parseFloat(a.bid)) ? Infinity : parseFloat(a.bid)
                const bidB = isNaN(parseFloat(b.bid)) ? Infinity : parseFloat(b.bid)
                return bidB - bidA
            }

        }
        ).concat(matchingItems?.filter(item => item[item?.ask ? 'ask' : 'bid'] === '-'))
        return filteredData
    }
    useEffect(() => {
        const filteredAskData = getUniqueData(arrDistinctScripExchanges, askData)
        setSortedAskData(filteredAskData);
    }, [askData])
    useEffect(() => {
        const filteredBidData = getUniqueData(arrDistinctScripExchanges, bidData)
        setSortedBidData(filteredBidData);
    }, [bidData])

    //Vaibhav Singh: 23-10-24: handleMarketDepthGridRowData handle all the data coming from touchline
    const handleMarketDepthGridRowData = useCallback((arrDetails) => {
        if (arrDistinctScripExchanges?.length > 0 && arrDetails?.length > 0) {
            for (let index = 0; index < arrDistinctScripExchanges.length; index++) {
                if (arrDistinctScripExchanges[index][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === `${arrDetails[BEST5_INDEX.SEGMENT_ID]}_${arrDetails[BEST5_INDEX.TOKEN]}`) {
                    const arrBidAndAskData = getBidAndAskGridRowData(arrDetails);
                    calculateBidPercent(arrDetails);
                    calculateAskPercent(arrDetails);
                    setBidData((prev) => ({
                        ...prev,
                        [arrDistinctScripExchanges[index][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: [...arrBidAndAskData[0]]
                    }));
                    setAskData((prev) => ({
                        ...prev,
                        [arrDistinctScripExchanges[index][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: [...arrBidAndAskData[1]]
                    }));
                    setBidPer((prev) => ({
                        ...prev,
                        [arrDistinctScripExchanges[index][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: [...arrBidAndAskData[2]]
                    }))
                    setAskPer((prev) => ({
                        ...prev,
                        [arrDistinctScripExchanges[index][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: [...arrBidAndAskData[3]]
                    }))
                } else { }
            }
        }
        else { }
    }, [arrDistinctScripExchanges]);
    useEffect(() => {
        const objBestFiveLastTick = dispatch(getWfhBestFiveLastTick());
        if (Object?.keys(objBestFiveLastTick)?.length > 0) {
            arrDistinctScripExchanges?.forEach((eachElement) => {
                const arrLastTickDepthData = objBestFiveLastTick[eachElement[WATCHLIST_GRID_INDEX?.SEGMENT_ID_TOKEN]];
                if (arrLastTickDepthData?.length > 0) {
                    if (eachElement[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === `${arrLastTickDepthData[BEST5_INDEX.SEGMENT_ID]}_${arrLastTickDepthData[BEST5_INDEX.TOKEN]}`) {
                        const arrBidAndAskLastTickData = getBidAndAskGridRowData(arrLastTickDepthData);
                        setBidData((prev) => ({
                            ...prev,
                            [eachElement[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: [...arrBidAndAskLastTickData[0]]
                        }));
                        setAskData((prev) => ({
                            ...prev,
                            [eachElement[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: [...arrBidAndAskLastTickData[1]]
                        }));
                        setBidPer((prev) => ({
                            ...prev,
                            [eachElement[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: [...arrBidAndAskLastTickData[2]]
                        }))
                        setAskPer((prev) => ({
                            ...prev,
                            [eachElement[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]]: [...arrBidAndAskLastTickData[3]]
                        }))
                    } else { }
                } else { }
            });
        } else { }
    }, [arrDistinctScripExchanges, dispatch]);
    useWFHMessages('bestfive', (e) => {
        handleMarketDepthGridRowData([...e.detail]);
    });


    const matchedHolding = holdingsScrips?.find(
        item => item?.ISIN === arrDistinctScripExchanges?.[0]?.[WATCHLIST_GRID_INDEX.ISIN_CODE]
    );


    const quantity = parseInt(matchedHolding?.TOTALFREEQUANTITY);

    return (
        <>
            {isVertical ?
                <div className='p-0 mt-3'>
                    <Container fluid className='p-0'>
                        <Row className='g-0 text-center justify-content-center'>
                            {sortedAskData?.map((each, i) => (
                                <>
                                    <Col md={5}></Col>
                                    <Col md={2}>
                                        <Row className="text-center justify-content-center background-default" key={i}>
                                            {each?.ask}
                                        </Row>
                                    </Col>
                                    <Col md={5}>
                                        {/*/ This will be removed when UI work is done  */}
                                        <div className='market-depth-flucuation market-depth-negative-background' style={{ width: `${each?.percent}%` }}></div>
                                        <div className="d-flex flex-column">
                                            <span key={i}>{`${each?.qty}(${each?.orders})`}</span>
                                        </div>
                                    </Col>
                                </>
                            ))}
                            {sortedBiddata?.map((each, i) => (
                                <>
                                    <Col md={5}>
                                        {/*/ This will be removed when UI work is done  */}
                                        <div className='market-depth-flucuation market-depth-positive-background' style={{ width: `${each?.percent}%` }}></div>
                                        <div className="d-flex flex-column">
                                            <span key={i}>{`${each?.qty}(${each?.orders})`}</span>
                                        </div>
                                    </Col>
                                    <Col md={2}>
                                        <Row className="text-center justify-content-center background-default" key={i}>
                                            {each?.bid}
                                        </Row>
                                    </Col>
                                    <Col md={5}></Col>
                                </>
                            ))}
                        </Row>
                    </Container>
                </div>
                :   // changes below
                <div className='p-0 mt-3'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col data-testid='price' className='font-medium font-size1 color-text text-center'>Price</Col>
                        </Row>
                        {sortedAskData?.map((each, i) => (
                            <Row className='g-0 text-center justify-content-center'>
                                <>
                                    <Col md={5}>
                                        <Container fluid className='p-0'>
                                            <Row className='g-0 my-1'>
                                                <Col className='d-flex justify-content-start'>
                                                    <div className='font-regular font-size1 color-text text-start'>&nbsp;</div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                    <Col md={2}>
                                        <Container fluid className='p-0 background-default position-relative'>
                                            <Row className='g-0 py-1' key={i}>
                                                <Col className='d-flex justify-content-center'>
                                                    <div data-testid='askData' className='font-medium font-size1 color-text text-center'>{each?.ask}</div>
                                                </Col>
                                            </Row>
                                            {holdingsScrips?.filter(item => item?.ISIN === arrDistinctScripExchanges?.[0]?.[WATCHLIST_GRID_INDEX.ISIN_CODE])?.[0]?.['nBuyAvgPrice'] === parseFloat(each?.ask) ?
                                                (quantity > 0 ? <div className='d-flex align-items-center price-pointer'>
                                                    <span className='icon-10 icon-price-pointer icon-dark me-1'></span>
                                                    <span className='icon-12 icon-portfolio icon-dark me-1'></span>
                                                    <span className='font-regular font-size1 color-text'>{quantity}</span>
                                                </div> : null)
                                                : null
                                            }
                                        </Container>
                                    </Col>
                                    <Col md={5}>
                                        <Container fluid className='p-0 ladderview-ask-column-wrapper'>
                                            <Row className='g-0 my-1' key={i}>
                                                <Col className='d-flex justify-content-end'>
                                                    <div data-testid='qtyOrderAsk' className={`font-regular font-size1 text-end pe-1 ${each?.exchange === DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT || each?.exchange === DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT ? 'ladderview-nse-ask-textcolor' : 'ladderview-bse-ask-textcolor'}`}>{`${each?.qty} (${each?.orders})`}</div>
                                                </Col>
                                            </Row>
                                            <div data-testid='percentAsk' className={`ladderview-flucuation h-100 ${each?.exchange === DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT || each?.exchange === DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT ? 'ladderview-nse-ask-background' : 'ladderview-bse-ask-background'}`} style={{ width: `${each?.percent}%` }}></div>
                                        </Container>
                                    </Col>
                                </>
                            </Row>
                        ))}
                        {sortedBiddata?.map((each, i) => (
                            <Row className='g-0 text-center justify-content-center'>
                                <>
                                    <Col md={5}>
                                        <Container fluid className='p-0 ladderview-bid-column-wrapper'>
                                            <Row className='g-0 my-1'>
                                                <Col className='d-flex justify-content-start'>
                                                    <div data-testid='qtyOrderBid' className={`font-regular font-size1 text-start ps-1 ${each?.exchange === DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT || each?.exchange === DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT ? 'ladderview-nse-bid-textcolor' : 'ladderview-bse-bid-textcolor'}`}>{`${each?.qty} (${each?.orders})`}</div>
                                                </Col>
                                                <div data-testid='percentBid' className={`ladderview-flucuation h-100 ${each?.exchange === DISPLAY_EXCHANGE_NAME.NSE_EXCHANGE_TEXT || each?.exchange === DISPLAY_EXCHANGE_NAME.NSX_EXCHANGE_TEXT ? 'ladderview-nse-bid-background' : 'ladderview-bse-bid-background'}`} style={{ width: `${each?.percent}%` }}></div>
                                            </Row>
                                        </Container>
                                    </Col>
                                    <Col md={2}>
                                        <Container fluid className='p-0 background-default position-relative'>
                                            <Row className='g-0 py-1' key={i}>
                                                <Col className='d-flex justify-content-center'>
                                                    <div data-testid='bidData' className='font-medium font-size1 color-text text-center'>{each?.bid}</div>
                                                </Col>
                                            </Row>
                                            {holdingsScrips?.filter(item => item?.ISIN === arrDistinctScripExchanges?.[0]?.[WATCHLIST_GRID_INDEX.ISIN_CODE])?.[0]?.['nBuyAvgPrice'] === parseFloat(each?.bid) ?
                                                (
                                                    quantity > 0 ? <div className='d-flex align-items-center price-pointer'>
                                                        <span className='icon-12 icon-price-pointer icon-dark me-1'></span>
                                                        <span className='icon-14 icon-portfolio icon-dark me-1'></span>
                                                        <span className='font-regular font-size1 color-text'>{quantity}</span>
                                                    </div> : null)
                                                : null
                                            }
                                        </Container>
                                    </Col>
                                    <Col md={5}>
                                        <Container fluid className='p-0'>
                                            <Row className='g-0 my-1' key={i}>
                                                <Col className='d-flex justify-content-end'>
                                                    <div className='font-regular font-size1 color-text text-end'>&nbsp;</div>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Col>
                                </>
                            </Row>
                        ))}
                    </Container>
                </div>
            }
        </>
    )
}
export default memo(PriceLadderView);